var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserO(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 11c1.612 0 3-1.527 3-3.5 0-2.769-.527-3.5-3-3.5s-3 .731-3 3.5c0 1.973 1.388 3.5 3 3.5zm0 2c-2.761 0-5-2.462-5-5.5S7.735 2 12 2s5 2.462 5 5.5-2.239 5.5-5 5.5zm3.032 3.07c-.093.043-.19.086-.293.127-.768.31-1.683.489-2.739.489-1.056 0-1.97-.179-2.738-.489a5.655 5.655 0 0 1-.293-.128c-3.5.455-3.852.746-3.942 3.029.08.032.169.066.265.1C6.67 19.688 8.855 20 12 20s5.331-.312 6.708-.802c.097-.034.185-.068.266-.1-.087-2.296-.461-2.578-3.942-3.029zm5.958 3.533c.006.245.01.426.01.563 0 0-1.325 1.834-9 1.834-7.674 0-9-1.834-9-1.834 0-.214.005-.383.014-.687.101-3.723.873-4.797 6.377-5.479 0 0 .783.686 2.61.686 1.825 0 2.608-.686 2.608-.686 5.565.69 6.293 1.78 6.38 5.603z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserO);
export default __webpack_public_path__ + "static/media/user-o.8943b2b3.svg";
export { ForwardRef as ReactComponent };